import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  releaseNotes: '',
  users: null,
  user: null,
  termsAcceptance: null,
  profile: null,
  userFeedback: null,
  geoIP: null,
  company: null,
}

const getters = {
  releaseNotes() {
    return axios.get(`/user/releasenotes`)
  },
  users() {
    return axios.get('/admin/users')
  },
  user(userId) {
    return axios.get(`/admin/user/${userId}`)
  },
  termsAcceptance() {
    return axios.get('/user/termsacceptance')
  },
  phmAirlines() {
    return axios.get('/Airline')
  },
  profile() {
    return axios.get('/user/profile')
  },
  company() {
    return axios.get('/company')
  },
}

const saves = {
  termsAcceptance() {
    return axios.post('/user/termsacceptance')
  },
  profile() {
    return axios.post('/user/profile')
  },
  geoIP() {
    return axios.post('/user/geoipuseracceptance')
  },
  userFeedback(feedback) {
    return axios.post('/user/createuserfeedback', feedback)
  },
  company(company) {
    return axios.post('/company', company)
  },
}

export default class UserService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
